var $13615450e96c337c$exports = {};
$13615450e96c337c$exports = {
    "help": `Ayuda`,
    "info": `Informaci\xf3n`
};


export {$13615450e96c337c$exports as default};
//# sourceMappingURL=es-ES.mjs.map
